import React, { useEffect } from 'react';
import MembOtpAthnApi from 'Apis/MembOtpAthnApi';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from "react-router-dom";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import EmlAthnModalUi from 'Utils/EmlAthnModalUi';
import MbpAthnTknCrtRqstApi from 'Apis/MbpAthnTknCrtRqstApi';
import { isMobile } from "react-device-detect";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MembOtpUnRegApi from 'Apis/MembOtpUnRegApi';
import useRecaptcha from 'Utils/useRecaptcha';
import MgpStore from 'Stores/Store';
import ApiResultModal from 'Components/ApiResultModal';
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}


const OtpAthn = () => {
    const { push: gtmPush } = useGtm();
    const navigate = useNavigate();
    const location = useLocation();
    const idntMthdCd = (location.state as any)?.idntMthdCd;
    const [emlAthnPrpsCd] = useState("OTP_UNREG");
    const [otpAthnNo,setotpAthnNo] = useState("");
    const [loginAlertTxt,setloginAlertTxt] = useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [resultModalConfirmText, setResultModalConfirmText] = useState("확인");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const [showEmlModal, setShowEmlModal] = useState(false);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();

    const openResultModal = (message: string, onClose?: () => void, confirmText: string = "확인") => {
        setResultModalMessage(message);
        setResultModalConfirmText(confirmText);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) {
            action();
        }
    };
    const OtpAthnNoHandler = (event:any) => {
        // 숫자만 허용하고 최대 6자리로 제한
        const value = event.currentTarget.value.replace(/[^0-9]/g, '').slice(0, 6);
        event.currentTarget.value = value;
        setotpAthnNo(value);
        setloginAlertTxt("");
    }
    const { getToken } = useRecaptcha();
    const [mbpAthnTkn,setMbpAthnTkn] = useState("");
    const reqKMCISForm:any = document.getElementById('reqKMCISForm');
    const tr_cert:any = document.getElementById("tr_cert");
    let mbpAthnTknVal:any
    var KMCIS_window;

    const popupX = Math.round(window.screenX + (window.outerWidth / 2) - (500 / 2));
    const popupY = Math.round(window.screenY + (window.outerHeight / 2) - (670 / 2));

    const EmlAthnPopFunc = (athnPrpsCd: string) => {
        if (isMobile) {
            setShowEmlModal(true);
        } else {
            const url = `/EmlAthnPop?emlAthnPrpsCd=${athnPrpsCd}&lang=${MgpStore.getState().LangSetState.Lang}`;
            window.open(url, "_blank", "width=550,height=800,left=" + popupX + ",top=" + popupY);
        }
    }

    
    const MembOtpAthnFunc = async (e:any) => {
        e.preventDefault();
        try {
            const token = await getToken('otp_auth');
            const Resp = await MembOtpAthnApi(otpAthnNo, token);
            switch(Resp.apiHdr.code) {
                case "ATHN0000": {
                    if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    const tsKst = getKstTimestamp();    
                    const adPayload = await fetchAdPayload( 'BBO');
                    try {

                        gtmPush('BBO_GA_Login_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                    const params = new URLSearchParams(window.location.search);
                    const referrer = params.get("referrer");
                    if (referrer) {
                        navigate(decodeURIComponent(referrer), { replace: true });
                    } else {
                        navigate("/", { replace: true });
                    }
                }
                break;
                case "ATHN2307":
                    setloginAlertTxt(langData&&langData.GLB_ATHN_NUM_FAIL_00);
                break;
                case "ATHN2203":
                    openResultModal(
                        langData&&langData.GLB_SESS_EXPR_DESC_00,
                        () => navigate("/login",{replace:true})
                    );
                break;
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('reCAPTCHA token failed', err);
        }
    }
    useEffect(() => {
        MbpAthnTknCrtRqstApi("OTP_UNREG",null).then((resq) => {
            setMbpAthnTkn(resq.apiBody.kmcTkn);
        });
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                if(resp.apiHdr.code == "ATHN0000") {
                    MembOtpUnRegApi().then(async (resq)=>{
                        if(resq.apiHdr.code == "MEMB0000") {
                            if (window.fbq) {
                                window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                            }
                            const tsKst = getKstTimestamp();
                            const adPayload = await fetchAdPayload( 'BBO');
                            try {

                                gtmPush('BBO_GA_Login_Complete', {
                                    ts: tsKst,
                                    ...adPayload,
                                });
                            } catch (gtmErr) {
                                if (typeof window !== 'undefined') {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        event: 'BBO_GA_Login_Complete',
                                        ts: tsKst,
                                        ...adPayload,
                                    });
                                }
                            }
                            openResultModal(
                                langData&&langData.LOGIN_OTP_ATHN_UNREG_DESC_00,
                                () => navigate("/", { replace: true })
                            );
                        }
                    })
                }
            });
        }

        const emlAthnRespFunc = (athnPrpsCd:string) => {
            if(athnPrpsCd !== emlAthnPrpsCd) {
                return;
            }
            MembOtpUnRegApi().then(async (resp)=>{
                if(resp.apiHdr.code == "MEMB0000") {
                    if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    const tsKst = getKstTimestamp();
                    const adPayload = await fetchAdPayload( 'BBO');
                    try {

                        gtmPush('BBO_GA_Login_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                    openResultModal(
                        langData&&langData.LOGIN_OTP_ATHN_UNREG_DESC_00,
                        () => navigate("/", { replace: true })
                    );
                }
            })
        }

        window.kmcRespFunc = kmcRespFunc;
        window.emlAthnRespFunc = emlAthnRespFunc;

        return () => {
            try { window.kmcRespFunc = undefined; } catch (e) {}
            try { window.emlAthnRespFunc = undefined; } catch (e) {}
        }
    },[langData, navigate, emlAthnPrpsCd]);
    async function openKMCISWindow (){
        if(!reqKMCISForm) {
            return;
        }
        if(isMobile == true) {
            reqKMCISForm.target = '';
        }else {
            KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
            
            if(KMCIS_window == null){
                openResultModal(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
            }
            reqKMCISForm.target = 'KMCISWindow';
        };
        reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
        reqKMCISForm.submit();
    }
    return(
        <div className='loginInputWrap'>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}`}</title>
            </Helmet>
            <div className='otpAthnDescWrap'>
                <h2>{langData&&langData.LOGIN_OTP_ATHN_MAIN_DESC_00}</h2>
                <p>{langData&&langData.LOGIN_OTP_ATHN_SUB_DESC_00}</p>
            </div>
            <form action="" onSubmit={MembOtpAthnFunc}>
                <ul className='loginInputUl'>
                    <li>
                        <input placeholder={`${langData&&langData.LOGIN_OTP_ATHN_INPUT_DESC_00}`} className='idInput otpInput' onChange={OtpAthnNoHandler}></input>
                        {/* OTP input */}
                    </li>
                    <p className='loginAlertTxt'>{loginAlertTxt}</p>
                </ul>
                <button className='loginBtn otpLoginBtn' type='submit'>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</button>
                {/* 로그인 */}
            </form>
            <div className='otpUnRegWrap'>
                <p>{langData&&langData.LOGIN_OTP_ATHN_UNREG_TITL_00}</p>
                <div>
                    {idntMthdCd === "EML" ?
                        <>
                        <button type="button" onClick={() => EmlAthnPopFunc("OTP_UNREG")}> 
                            <p>{langData&&langData.LOGIN_OTP_ATHN_UNREG_BTN_00}</p>
                        </button>
                        {showEmlModal && (
                            <EmlAthnModalUi
                                emlAthnPrpsCd={emlAthnPrpsCd}
                                onSuccess={(athnPrpsCd: string) => {
                                    setShowEmlModal(false);
                                    if (typeof window.emlAthnRespFunc === 'function') {
                                        window.emlAthnRespFunc(athnPrpsCd);
                                    }
                                }}
                                onClose={() => setShowEmlModal(false)}
                            />
                        )}
                        </>
                    :
                        <form id="reqKMCISForm" method="post" name="reqKMCISForm" action="#">
                            <input type="hidden" id="tr_cert" className="tr_cert" value={mbpAthnTkn} name="tr_cert"/>
                            <input type="hidden" className="tr_url" value={process.env.REACT_APP_KMC_REDIRECT_URL}  name="tr_url"/>
                            <input type="hidden" value={"V2"}      name="tr_ver"/>
                            <button type="submit"  onClick={() => openKMCISWindow()}>
                                <p>{langData&&langData.LOGIN_OTP_ATHN_UNREG_BTN_00}</p>
                            </button>
                        </form>
                    }
                </div>
            </div>
            <div className="capthCpyr">
                {/* reCAPTCHA provided at app root; per-page provider removed */}
                <p>
                    This site is protected by reCAPTCHA and the Google
                    <br />
                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                    <a href="https://policies.google.com/terms"  target="_blank">Terms of Service</a> apply.
                </p>
            </div>
        </div>
    )
}

export default OtpAthn;